// Generated from SVG to Code Figma Plugin

export const BaseFillTips = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.51758 20.5996V3.59961H18.5176V20.5996L12.0176 17.4633L5.51758 20.5996Z"
      fill="#0086FF"
      stroke="#0086FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.04"
    />
  </svg>
);
